module.exports = __webpack_public_path__ + "img/kidpic.dd7990f1.png";